import React from "react";
import { DatePicker } from "antd";
import moment from "moment";

export class DatePickerComponent extends React.Component {
  onChange = (e) => {
    this.props.onChange(e ? moment(e).format("YYYY-MM-DD HH:mm:ss") : '');
  };
  render() {
    return (
      <DatePicker
        {...this.props}
        showTime
        value={
          this.props.value && moment(this.props.value, "YYYY-MM-DD HH:mm:ss")
        }
        onChange={this.onChange}
      />
    );
  }
}
// 时间
export class DatePickerTimeComponent extends React.Component {
  onChange = (e) => {
    this.props.onChange(e ? moment(e).format("HH:mm:ss") : '');
  };
  render() {
    return (
      <DatePicker.TimePicker
        {...this.props}
        value={this.props.value && moment(this.props.value, "HH:mm:ss")}
        onChange={this.onChange}
      />
    );
  }
}
// 周
export class DatePickerWeekComponent extends React.Component {
  onChange = (e, dateString) => {
    this.props.onChange(
      {
        weekNo: dateString,
        weekDate: e,
        weekDays: [
          moment(e).day(1).format("YYYY-MM-DD"),
          moment(e).day(2).format("YYYY-MM-DD"),
          moment(e).day(3).format("YYYY-MM-DD"),
          moment(e).day(4).format("YYYY-MM-DD"),
          moment(e).day(5).format("YYYY-MM-DD"),
          moment(e).day(6).format("YYYY-MM-DD"),
          moment(e).day(7).format("YYYY-MM-DD"),
        ],
      },
      dateString
    );
  };
  render() {
    console.log("weekValue", this.props.value);
    return (
      <DatePicker.WeekPicker
        {...this.props}
        value={this.props.value && this.props.value.weekDate}
        onChange={this.onChange}
      />
    );
  }
}

export default DatePickerComponent;
